// src/data/blog.js

// This is your "database" for blog posts.
// To add a new post, just add a new object to this array.
export const blogPosts = [
  {
    id: "blog-1",
    title: 'Blog 1',
    date: '10-23',
    tags: ['react', 'web-development'],
    content: [
      { type: 'paragraph', value: 'This is the first paragraph of the blog post. It can be a long text that introduces the topic.' },
      { type: 'subheading', value: 'A Subheading for a New Section' },
      { type: 'paragraph', value: 'This is a paragraph under a subheading. It can contain more details about the topic.' },
      { type: 'image', value: '/projects/project-1/hero.jpg' },
      { type: 'paragraph', value: 'This paragraph comes after an image, providing more context or continuing the story.' }
    ]
  },
  {
    id: "blog-2",
    title: 'Blog 2',
    date: '09-23',
  },
  {
    id: "blog-3",
    title: 'Blog 3',
    date: '08-23',
  },
  {
    id: "blog-4",
    title: 'Blog 4',
    date: '07-23',
  },
];